import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";

import {
  addProductStyleAsync,
  addProductinseamAsync,
  deleteProductinseamAsync,
  editProductStyleAsync,
  editProductinseamAsync,
  getProductStyleAsync,
  getProductinseamAsync,
} from "../../../../store/services/productInfoServices";


const Inseam = () => {
  const dispatch = useDispatch();
  const {
    getProductinseamStatus,
    getProductinseamError,
    getProductinseamData,
    addProductinseamStatus,
    addProductinseamData,
    addProductinseamError,

    editProductinseamStatus,
    editProductinseamError,
    editProductinseamData,

    deleteProductinseamData,
    deleteProductinseamStatus,
    deleteProductinseamError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductinseamAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductinseamData?.length
    ? getProductinseamData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedinseam, setSelectedinseam] = useState();
  const [addinseamMode, setAddinseamMode] = useState(false);
  const [addinseamData, setAddinseamData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedinseam", selectedinseam);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductinseamStatus === asyncStatus.SUCCEEDED) {
      setAddinseamMode(false);
      setSaveDisabled(true);
      setAddinseamData();
    }
  }, [, addProductinseamStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductinseamAsync(selectedinseam?.inseam_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductinseamStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedinseam();
    }
  }, [, deleteProductinseamStatus]);
  useEffect(() => {
    if (editProductinseamStatus === asyncStatus.SUCCEEDED) {
      setSelectedinseam();
      setEditMode(false);
    }
  }, [, editProductinseamStatus]);
console.log("getProductinseamData",getProductinseamData,editProductinseamData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this inseam?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Fit Category"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Inseam Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddinseamMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addinseamMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addinseamMode || !selectedinseam}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddinseamMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addinseamMode || !selectedinseam}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductinseamStatus === asyncStatus.LOADING ||
                  editProductinseamStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addinseamData) {
                    dispatch(addProductinseamAsync(addinseamData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedinseam, ...editData };
                    delete a.id;
                    dispatch(editProductinseamAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "inseam_id", headerName: "ID", flex: true },
                  {
                    field: "inseam_name",
                    headerName: "inseam Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedinseam(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductinseamStatus === asyncStatus.IDLE ||
                  getProductinseamStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addinseamMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Inseam:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddinseamData({
                            ...addinseamData,
                          inseam_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddinseamData({
                            ...addinseamData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedinseam ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedinseam?.inseam_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Inseam:",
                    comp: (
                      <InputComp
                        key={selectedinseam?.inseam_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                          inseam_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedinseam?.inseam_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedinseam?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedinseam?.is_active ? true : false
                        }
                        checked={selectedinseam?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any inseam</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductinseamError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductinseamError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductinseamError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductinseamError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedinseam(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedinseam(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default Inseam;
